var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*eslint no-useless-escape: 0*/
import React, { useState, useEffect, useMemo } from 'react';
import { MenuItem } from '@mui/material';
import { MODOS, MENSAGENS, validarCNPJ, getNomeFormatado } from '../../../utils';
import { ROUTES, FUNCIONALIDADES, PAGINAS } from '../../../routes';
import ContainerPainel from '../../../components/container_painel';
import { BoxPrincipal, BoxBotoes } from '../../../components/form_box';
import Loading from '../../../components/loading';
import { useNavigate, useParams } from 'react-router-dom';
import { getOrgaoEmpresa, cadastrarOrgaoEmpresa, alterarOrgaoEmpresa, excluirOrgaoEmpresa, consultarEnderecoCEP, getEstadosAtivos, getCidadesAtivos, } from '../../../api';
import { BotaoSalvar, BotaoExcluir, BotaoFechar, BotaoEditar } from '../../../components/botoes';
import InputText, { InputDados } from '../../../components/input_dados';
import { useAuth } from '../../../contexts/auth/AuthContext';
var getTextoOuNulo = function (valor) { return (valor === null || valor === void 0 ? void 0 : valor.trim()) || null; };
var getDigitosOuNulo = function (valor) { return (valor === null || valor === void 0 ? void 0 : valor.replace(/\D/g, '')) || null; };
var OrgaosEmpresasEditar = function () {
    var _a = useAuth(), addMensagem = _a.addMensagem, getAcoesFuncionalidade = _a.getAcoesFuncionalidade;
    var AcoesFuncionalidade = useMemo(function () { return getAcoesFuncionalidade(FUNCIONALIDADES.ORGAOS_EMPRESAS); }, [getAcoesFuncionalidade]);
    var navigate = useNavigate();
    var _b = useState(true), loading = _b[0], setLoading = _b[1];
    var _c = useState(true), LoadingInicio = _c[0], setLoadingInicio = _c[1];
    var _d = useParams(), id = _d.id, modo = _d.modo;
    var _e = useState(''), Nome = _e[0], setNome = _e[1];
    var _f = useState(''), CNPJ = _f[0], setCNPJ = _f[1];
    var _g = useState(''), Email = _g[0], setEmail = _g[1];
    var _h = useState(''), Telefone = _h[0], setTelefone = _h[1];
    var _j = useState(''), EnderecoCEP = _j[0], setEnderecoCEP = _j[1];
    var _k = useState(''), EnderecoLogradouro = _k[0], setEnderecoLogradouro = _k[1];
    var _l = useState(''), EnderecoNumero = _l[0], setEnderecoNumero = _l[1];
    var _m = useState(''), EnderecoBairro = _m[0], setEnderecoBairro = _m[1];
    var _o = useState(''), EnderecoComplemento = _o[0], setEnderecoComplemento = _o[1];
    var _p = useState('-1'), EnderecoCidade = _p[0], setEnderecoCidade = _p[1];
    var _q = useState('-1'), EnderecoEstado = _q[0], setEnderecoEstado = _q[1];
    var _r = useState([]), CidadesDisponiveis = _r[0], setCidadesDisponiveis = _r[1];
    var _s = useState([]), EstadosDisponiveis = _s[0], setEstadosDisponiveis = _s[1];
    var _t = useState('Ativo'), Situacao = _t[0], setSituacao = _t[1];
    var DESABILITAR_CAMPOS = modo == MODOS.VISUALIZAR || modo == MODOS.EXCLUIR;
    useEffect(function () {
        carregarDados();
        return function () { };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var carregarDados = function () { return __awaiter(void 0, void 0, void 0, function () {
        var EstadosAux, OrgaoEmpresaAux, nome, cnpj, email, telefone, endereco_cep, endereco_logradouro, endereco_numero, endereco_bairro, endereco_complemento, cidade_id, estado_id, situacao, CidadeID_1, EstadoID_1, EstadoAux, CidadesAux, CidadeAux;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getEstadosAtivos()];
                case 1:
                    EstadosAux = _a.sent();
                    setEstadosDisponiveis(EstadosAux);
                    if (!id) return [3 /*break*/, 4];
                    return [4 /*yield*/, getOrgaoEmpresa(id)];
                case 2:
                    OrgaoEmpresaAux = _a.sent();
                    if (!OrgaoEmpresaAux) return [3 /*break*/, 4];
                    nome = OrgaoEmpresaAux.nome, cnpj = OrgaoEmpresaAux.cnpj, email = OrgaoEmpresaAux.email, telefone = OrgaoEmpresaAux.telefone, endereco_cep = OrgaoEmpresaAux.endereco_cep, endereco_logradouro = OrgaoEmpresaAux.endereco_logradouro, endereco_numero = OrgaoEmpresaAux.endereco_numero, endereco_bairro = OrgaoEmpresaAux.endereco_bairro, endereco_complemento = OrgaoEmpresaAux.endereco_complemento, cidade_id = OrgaoEmpresaAux.cidade_id, estado_id = OrgaoEmpresaAux.estado_id, situacao = OrgaoEmpresaAux.situacao;
                    setNome(nome);
                    setCNPJ(cnpj);
                    setEmail(email);
                    setTelefone(telefone);
                    setEnderecoCEP(endereco_cep);
                    setEnderecoLogradouro(endereco_logradouro);
                    setEnderecoNumero(endereco_numero);
                    setEnderecoBairro(endereco_bairro);
                    setEnderecoComplemento(endereco_complemento);
                    setSituacao(situacao);
                    CidadeID_1 = cidade_id;
                    EstadoID_1 = estado_id;
                    if (!EstadoID_1) return [3 /*break*/, 4];
                    EstadoAux = EstadosAux === null || EstadosAux === void 0 ? void 0 : EstadosAux.find(function (item) { return item.id == EstadoID_1; });
                    setEnderecoEstado(EstadoAux === null || EstadoAux === void 0 ? void 0 : EstadoAux.sigla);
                    return [4 /*yield*/, getCidadesAtivos(EstadoAux === null || EstadoAux === void 0 ? void 0 : EstadoAux.sigla)];
                case 3:
                    CidadesAux = _a.sent();
                    setCidadesDisponiveis(CidadesAux);
                    if (CidadeID_1) {
                        CidadeAux = CidadesAux === null || CidadesAux === void 0 ? void 0 : CidadesAux.find(function (item) { return item.id == CidadeID_1; });
                        setEnderecoCidade(CidadeAux === null || CidadeAux === void 0 ? void 0 : CidadeAux.codigo_ibge);
                    }
                    _a.label = 4;
                case 4:
                    setLoadingInicio(false);
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var validarDados = function () {
        if (!Nome || Nome.trim() == '') {
            alert("Nome ".concat(MENSAGENS.PREENCHIMENTO_OBRIGATORIO));
            return false;
        }
        // Os demais campos são opcionais: valida o formato apenas do que foi
        // preenchido, sem cobrar preenchimento.
        var RegexCNPJ = new RegExp(/^\d{2}\.?\d{3}\.?\d{3}\/?\d{4}\-?\d{2}$/);
        if ((CNPJ === null || CNPJ === void 0 ? void 0 : CNPJ.trim()) && (!RegexCNPJ.test(CNPJ) || !validarCNPJ(CNPJ))) {
            alert('O CNPJ informado é inválido');
            return false;
        }
        var RegexEmail = new RegExp(/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/);
        if ((Email === null || Email === void 0 ? void 0 : Email.trim()) && !RegexEmail.test(Email)) {
            alert('O Email informado é inválido');
            return false;
        }
        if ((Telefone === null || Telefone === void 0 ? void 0 : Telefone.trim()) && Telefone.trim().length < 10) {
            alert('Telefone inválido');
            return false;
        }
        if ((EnderecoCEP === null || EnderecoCEP === void 0 ? void 0 : EnderecoCEP.trim()) && EnderecoCEP.trim().length < 8) {
            alert('CEP inválido');
            return false;
        }
        return true;
    };
    var salvarDados = function () { return __awaiter(void 0, void 0, void 0, function () {
        var EstadoID, CidadeID, TemEstado, TemCidade, Dados, Resp, _a;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (!validarDados())
                        return [2 /*return*/];
                    setLoading(true);
                    EstadoID = (_b = EstadosDisponiveis === null || EstadosDisponiveis === void 0 ? void 0 : EstadosDisponiveis.find(function (item) { return item.sigla == EnderecoEstado; })) === null || _b === void 0 ? void 0 : _b.id;
                    CidadeID = (_c = CidadesDisponiveis === null || CidadesDisponiveis === void 0 ? void 0 : CidadesDisponiveis.find(function (item) { return item.codigo_ibge == EnderecoCidade; })) === null || _c === void 0 ? void 0 : _c.id;
                    TemEstado = !!EnderecoEstado && EnderecoEstado != '-1';
                    TemCidade = !!EnderecoCidade && EnderecoCidade != '-1';
                    Dados = {
                        nome: getNomeFormatado(Nome),
                        // Campo em branco precisa ir como null, não como string vazia: cnpj tem
                        // índice unique e duas strings vazias colidem, enquanto vários NULL
                        // convivem. O optional chaining também protege registros gravados sem
                        // esses campos, que chegam aqui como null.
                        cnpj: getDigitosOuNulo(CNPJ),
                        email: getTextoOuNulo(Email),
                        telefone: getDigitosOuNulo(Telefone),
                        endereco_cep: getDigitosOuNulo(EnderecoCEP),
                        endereco_logradouro: getTextoOuNulo(EnderecoLogradouro),
                        endereco_numero: getTextoOuNulo(EnderecoNumero),
                        endereco_bairro: getTextoOuNulo(EnderecoBairro),
                        endereco_complemento: getTextoOuNulo(EnderecoComplemento),
                        cidade_id: TemCidade ? CidadeID : null,
                        estado_id: TemEstado ? EstadoID : null,
                        situacao: Situacao,
                    };
                    _a = modo;
                    switch (_a) {
                        case MODOS.CADASTRAR: return [3 /*break*/, 1];
                        case MODOS.ALTERAR: return [3 /*break*/, 3];
                    }
                    return [3 /*break*/, 5];
                case 1: return [4 /*yield*/, cadastrarOrgaoEmpresa(Dados)];
                case 2:
                    Resp = _d.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, alterarOrgaoEmpresa(Dados, id !== null && id !== void 0 ? id : '')];
                case 4:
                    Resp = _d.sent();
                    return [3 /*break*/, 5];
                case 5:
                    setLoading(false);
                    if ((Resp === null || Resp === void 0 ? void 0 : Resp.Status) == 'OK') {
                        addMensagem(modo == MODOS.CADASTRAR ? MENSAGENS.REGISTRO_CADASTRADO_SUCESSO : MENSAGENS.REGISTRO_ALTERADO_SUCESSO);
                        navigate(ROUTES.ORGAOS_EMPRESAS);
                    }
                    else if (Resp) {
                        alert(Resp.Mensagem);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var excluirRegistro = function () { return __awaiter(void 0, void 0, void 0, function () {
        var Resp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!confirm(MENSAGENS.EXCLUIR_REGISTRO))
                        return [2 /*return*/];
                    setLoading(true);
                    return [4 /*yield*/, excluirOrgaoEmpresa(id !== null && id !== void 0 ? id : '')];
                case 1:
                    Resp = _a.sent();
                    setLoading(false);
                    if ((Resp === null || Resp === void 0 ? void 0 : Resp.Status) == 'OK') {
                        addMensagem(MENSAGENS.REGISTRO_EXCLUIDO_SUCESSO);
                        navigate(ROUTES.ORGAOS_EMPRESAS);
                    }
                    else if (Resp) {
                        alert(Resp.Mensagem);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var editarRegistro = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            navigate("".concat(ROUTES.ORGAOS_EMPRESAS, "/").concat(id, "/").concat(MODOS.ALTERAR));
            return [2 /*return*/];
        });
    }); };
    var buscarCEP = function (CEPParm) { return __awaiter(void 0, void 0, void 0, function () {
        var CEP, Endereco;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    CEP = CEPParm.replace(/\D/g, '');
                    if (CEP.length < 8)
                        return [2 /*return*/];
                    setLoading(true);
                    console.log('CEP', CEP);
                    return [4 /*yield*/, consultarEnderecoCEP(CEP)];
                case 1:
                    Endereco = _a.sent();
                    console.log('Endereco', JSON.stringify(Endereco));
                    if (!(Endereco === null || Endereco === void 0 ? void 0 : Endereco.cep)) return [3 /*break*/, 3];
                    setEnderecoLogradouro(Endereco.logradouro);
                    setEnderecoBairro(Endereco.bairro);
                    setEnderecoComplemento(Endereco.complemento);
                    return [4 /*yield*/, onChangeEstado(Endereco.uf)];
                case 2:
                    _a.sent();
                    setEnderecoCidade(Endereco.ibge);
                    return [3 /*break*/, 4];
                case 3:
                    setEnderecoLogradouro('');
                    setEnderecoBairro('');
                    setEnderecoComplemento('');
                    setEnderecoCidade('');
                    setEnderecoEstado('');
                    alert('CEP não encontrado');
                    _a.label = 4;
                case 4:
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var onChangeEstado = function (Estado) { return __awaiter(void 0, void 0, void 0, function () {
        var CidadesAux;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setEnderecoEstado(Estado);
                    return [4 /*yield*/, getCidadesAtivos(Estado)];
                case 1:
                    CidadesAux = _a.sent();
                    setCidadesDisponiveis(CidadesAux);
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsx(ContainerPainel, __assign({ modo: modo, pagina_acima: PAGINAS.ORGAOS_EMPRESAS, pagina_especifica_permissao: FUNCIONALIDADES.ORGAOS_EMPRESAS, link_pagina_acima: ROUTES.ORGAOS_EMPRESAS }, { children: _jsxs(BoxPrincipal, { children: [!LoadingInicio && (_jsxs(_Fragment, { children: [_jsx(InputDados, { id: 'id', variant: 'outlined', disabled: true, label: 'C\u00F3digo', value: id, size: 'small' }), _jsx(InputDados, { id: 'nome', label: 'Nome', value: Nome, onChange: function (event) { return setNome(event.target.value); }, variant: 'outlined', size: 'small', fullWidth: true, required: true, disabled: DESABILITAR_CAMPOS }), _jsx(InputDados, { id: 'cnpj', label: 'CNPJ', value: CNPJ, onChange: function (event) { return setCNPJ(event.target.value); }, mask: '99.999.999/9999-99', variant: 'outlined', size: 'small', fullWidth: true, disabled: DESABILITAR_CAMPOS }), _jsx(InputDados, { id: 'email', label: 'Email', value: Email, onChange: function (event) { return setEmail(event.target.value); }, variant: 'outlined', size: 'small', fullWidth: true, disabled: DESABILITAR_CAMPOS }), _jsx(InputDados, { id: 'telefone', label: 'Telefone', value: Telefone, onChange: function (event) { return setTelefone(event.target.value); }, variant: 'outlined', size: 'small', mask: '(99) 9999-9999', fullWidth: true, disabled: DESABILITAR_CAMPOS }), _jsx(InputDados, { id: 'cep', label: 'CEP', value: EnderecoCEP, onChange: function (event) { return setEnderecoCEP(event.target.value); }, onBlur: function (event) { return buscarCEP(event.target.value); }, variant: 'outlined', size: 'small', mask: '99.999-999', fullWidth: true, disabled: DESABILITAR_CAMPOS }), _jsx(InputDados, { id: 'logradouro', label: 'Logradouro', value: EnderecoLogradouro, onChange: function (event) { return setEnderecoLogradouro(event.target.value); }, variant: 'outlined', size: 'small', fullWidth: true, disabled: DESABILITAR_CAMPOS }), _jsx(InputDados, { id: 'numero', label: 'N\u00FAmero', value: EnderecoNumero, onChange: function (event) { return setEnderecoNumero(event.target.value); }, variant: 'outlined', size: 'small', fullWidth: true, disabled: DESABILITAR_CAMPOS }), _jsx(InputDados, { id: 'bairro', label: 'Bairro', value: EnderecoBairro, onChange: function (event) { return setEnderecoBairro(event.target.value); }, variant: 'outlined', size: 'small', fullWidth: true, disabled: DESABILITAR_CAMPOS }), _jsx(InputDados, { id: 'complemento', label: 'Complemento', value: EnderecoComplemento, onChange: function (event) { return setEnderecoComplemento(event.target.value); }, variant: 'outlined', size: 'small', fullWidth: true, disabled: DESABILITAR_CAMPOS }), EnderecoEstado && (_jsxs(InputDados, __assign({ select: true, id: 'estado', label: 'Estado', placeholder: 'Estado', value: EnderecoEstado, onChange: function (event) {
                                onChangeEstado(event.target.value);
                            }, fullWidth: true, disabled: DESABILITAR_CAMPOS }, { children: [_jsx(MenuItem, __assign({ value: '-1' }, { children: 'Selecione ...' }), '-1'), EstadosDisponiveis === null || EstadosDisponiveis === void 0 ? void 0 : EstadosDisponiveis.map(function (item) { return (_jsx(MenuItem, __assign({ value: item.sigla }, { children: item.nome }), item.sigla)); })] }))), EnderecoCidade && (_jsxs(InputDados, __assign({ select: true, id: 'cidade', label: 'Cidade', placeholder: 'Cidade', value: EnderecoCidade, onChange: function (event) {
                                setEnderecoCidade(event.target.value);
                            }, fullWidth: true, disabled: DESABILITAR_CAMPOS }, { children: [_jsx(MenuItem, __assign({ value: '-1' }, { children: 'Selecione ...' }), '-1'), CidadesDisponiveis === null || CidadesDisponiveis === void 0 ? void 0 : CidadesDisponiveis.map(function (item) { return (_jsx(MenuItem, __assign({ value: item.codigo_ibge }, { children: item.nome }), item.codigo_ibge)); })] }))), _jsxs(InputText, __assign({ select: true, id: 'situacao' // obrigatorio
                            , label: 'Situa\u00E7\u00E3o' // obrigatorio
                            , placeholder: 'Situa\u00E7\u00E3o', value: Situacao, onChange: function (event) {
                                setSituacao(event.target.value);
                            }, size: 'small', fullWidth: true, disabled: DESABILITAR_CAMPOS }, { children: [_jsx(MenuItem, __assign({ value: 'Ativo' }, { children: "Ativo" })), _jsx(MenuItem, __assign({ value: 'Inativo' }, { children: "Inativo" }))] })), _jsxs(BoxBotoes, { children: [(MODOS.ALTERAR == modo || MODOS.CADASTRAR == modo) && _jsx(BotaoSalvar, { onClick: salvarDados }), MODOS.EXCLUIR == modo && _jsx(BotaoExcluir, { onClick: excluirRegistro }), MODOS.VISUALIZAR == modo && _jsx(BotaoEditar, { onClick: editarRegistro, disabled: !AcoesFuncionalidade['ALTERAR'] }), _jsx(BotaoFechar, { modo: modo })] })] })), loading && _jsx(Loading, {})] }) })));
};
export default OrgaosEmpresasEditar;
